import { getUiLocale } from './locale';
import { tx } from './pack';

const LABEL_KEY: Record<string, string> = {
  开始: 'form.edit.step.start',
  结束: 'form.edit.step.end',
  收起: 'form.edit.step.packUp',
  封面: 'form.edit.step.cover',
  表单: 'form.edit.step.form',
  表单步骤一: 'form.edit.step.form1',
  表单步骤二: 'form.edit.step.form2',
  表单步骤三: 'form.edit.step.form3',
  表单步骤1: 'form.edit.step.form1',
  表单步骤2: 'form.edit.step.form2',
  表单步骤3: 'form.edit.step.form3',
};

/** 步骤条展示文案。结束/收起按 value 走词表，不读 settings 里的 label。其余中文锁死现网 label，英/越按 key 翻译。 */
export function formPageLabel(label: string, value?: string) {
  if (value === 'end' || value === 'packUp') {
    const canonical = value === 'end' ? '结束' : '收起';
    return tx(null, LABEL_KEY[canonical], canonical);
  }
  if (!label) {
    return label;
  }
  if (getUiLocale() === 'zh-CN') {
    return label;
  }
  const key = LABEL_KEY[label];
  if (key) {
    return tx(null, key, label);
  }
  const step = label.match(/^表单步骤(\d+)$/);
  if (step) {
    return tx(null, 'form.edit.step.formN', '表单步骤{{n}}', { n: step[1] });
  }
  return label;
}

/** 采集项类型展示名。type 仍存「自定义」，只翻译展示。 */
export function formTypeLabel(label: string) {
  if (label === '自定义') {
    return tx(null, 'form.edit.field.custom', '自定义');
  }
  return label;
}
